<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Flyt opfølgninger</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content class="align-center">
  <p>Hvilken brugers opfølgninger skal flyttes?</p>

  <form [formGroup]="form" [attr.autocomplete]="'off'">
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Flyttes fra</mat-label>
        <mat-select formControlName="transferFrom">
          @for (user of fromUsers; track user) {
            <mat-option [value]="user">{{ user }}</mat-option>
          }
        </mat-select>
        <mat-icon matSuffix class="select-arrow">keyboard_arrow_down</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Flyttes til</mat-label>
        <input formControlName="transferTo" matInput />
        @if (unknownUser) {
          <mat-hint>Brugeren er ukendt eller har endnu ingen opfølgninger.</mat-hint>
        }
      </mat-form-field>
    </div>
  </form>

  <div mat-dialog-actions class="align-center">
    <button mat-raised-button (click)="transfer()" [disabled]="$safeNavigationMigration(form?.invalid)" matTooltip="Flyt opfølgninger">Flyt opfølgninger</button>

    <button (click)="cancel()" class="modal-cancel" mat-raised-button>Fortryd</button>
  </div>
</div>
